/* remove all the id values from an object */
function removeIds(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj // Base case: not an object, or null, return as is
  }

  if (Array.isArray(obj)) {
    // If it's an array, recursively process each element
    return obj.map((item) => removeIds(item))
  }

  // If it's an object, process its properties
  const newObj = {}
  for (const key in obj) {
    if (key === 'segmentId') {
      // If the key is 'segmentId', keep the entire object as is, without recursion.
      // This preserves the 'id' within it.
      newObj[key] = obj[key]
    } else if (key !== 'id') {
      // For other keys (not 'id'), perform the recursive call.
      newObj[key] = removeIds(obj[key])
    }
  }
  return newObj
}

/* remove rules that has rewards not setup to sum to 100 exactly */
function getRulesWithInvalidRewards(rules) {
  const rulesWithInvalidRewards = []
  rules.forEach((rule, index) => {
    let totalPercentage = 0
    rule.rewards.map((reward) => {
      totalPercentage += reward.percentage
    })
    if (totalPercentage > 100) {
      rulesWithInvalidRewards.push(index + 1)
    }
  })
  return rulesWithInvalidRewards
}

function convertStringToArray(value) {
  // replace(/\s/g, "") remove all white spaces from the string
  return Array.isArray(value) ? value : value.replace(/\s/g, '').split(',')
}

const NAMED_REWARD_TYPE_BY_VALUE = {
  cart: 5,
  new_to_catgory: 6,
  existing_to_catgory: 7,
}

function mapNamedRewardTypeForPayload(reward) {
  const raw = String(reward.rewardValue ?? '')
    .trim()
    .toLowerCase()
  const rewardType = NAMED_REWARD_TYPE_BY_VALUE[raw]
  if (rewardType !== undefined) {
    return { ...reward, rewardType, rewardValue: '0' }
  }
  return reward
}

function offerIdFormValueFromApiReward(reward) {
  const { type, rewardValue } = reward;

  if (type === 5) {
    return 'CART';
  }

  if (type === 6) {
    return 'NEW_TO_CATGORY';
  }

  if (type === 7) {
    return 'EXISTING_TO_CATGORY';
  }

  return rewardValue;
}

function constructRules(rules, existingNothingRewards) {
  return rules.map((rule) => {
    let updatedRule = Object.assign({}, rule)
    if (rule.type === 3) {
      updatedRule = {
        ...updatedRule,
        segmentId:
          rule.segmentType === 'NEW_APP_SIGN_UP' ? 0 : rule?.segmentId?.id,
      }
    }

    if (rule?.policy?.sequences) {
      const sequencesArr = convertStringToArray(rule.policy.sequences)
      updatedRule.policy = {
        ...updatedRule.policy,
        sequences: sequencesArr.map((seq) => Number(seq)),
      }
    } else if (rule.policy) {
      updatedRule.policy.sequences = null
    }

    // add NOTHING option for rules that does not meet 100%
    const totalPercentage = rule.rewards.reduce(
      (acc, reward) => acc + reward.percentage,
      0
    )
    let nothingReward = {}

    // If id exists in rule and rule.id exists in existingNothingRewards, process. Else, continue
    if ('id' in rule && existingNothingRewards[rule.id]) {
      nothingReward = {
        ...existingNothingRewards[rule.id],
        percentage: 100 - totalPercentage,
      }
    }

    const newRewards =
      totalPercentage < 100 || Object.keys(nothingReward).length !== 0
        ? [
            ...rule.rewards,
            {
              ...nothingReward,
              rewardType: 4,
              rewardValue: '0',
              percentage: 100 - totalPercentage,
            },
          ]
        : rule.rewards // Keep the original array if totalPercentage = 100

    // deep copy rewards array before modifying
    updatedRule.rewards = [
      ...newRewards.map((reward) => {
        const rewardForApi = mapNamedRewardTypeForPayload(reward)
        const updatedReward = {
          ...rewardForApi,
          percentage: rewardForApi.percentage * 100, // multiply by 100 for API payload
        }

        // add validityPolicy for NOTHING reward
        if (
          rewardForApi.rewardType === 4 &&
          !rewardForApi?.validityPolicy?.cutOffTime
        ) {
          updatedReward.validityPolicy = {
            cutOffTime: '00:00',
          }
        } else {
          const newValidityPolicy = {
            type: reward.validityPolicy?.type,
            cutOffTime: '00:00',
            durationInHours: 0,
          }

          // update cutOffTime
          if (
            reward?.validityPolicy?.cutOffTime &&
            reward.validityPolicy.cutOffTime !== '0'
          ) {
            const timeParts = reward.validityPolicy.cutOffTime.split(':')
            newValidityPolicy.cutOffTime = `${timeParts[0]}:${timeParts[1]}`
          }

          // update durationInHours
          if (reward?.validityPolicy?.durationInHours) {
            newValidityPolicy.durationInHours =
              reward.validityPolicy.durationInHours * 24
          }

          updatedReward.validityPolicy = newValidityPolicy
        }

        return updatedReward
      }),
    ]

    // cleanup keys for POST/UPDATE call
    delete updatedRule.uid
    delete updatedRule.segmentType
    delete updatedRule.isEnabled
    updatedRule.rewards.forEach((reward) => {
      delete reward.uid
    })

    return updatedRule
  })
}

export {
  removeIds,
  getRulesWithInvalidRewards,
  convertStringToArray,
  constructRules,
  offerIdFormValueFromApiReward,
}
